<template>
  <div>
    <Header></Header>
    <div class="index-body intro-body">
      <div class="banner">
        <div class="title wrapper-box">
          <img src="../../../static/img/web_img/banner_title.png" />
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="img-box">
            <img src="../../../static/img/web_img/img_yewu4.png" />
          </div>
          <div class="info-box">
            <h2>移库换标</h2>
            <h5>为用户提供专业系统化管理的退货清点、贴标发货服务，拯救您的库存</h5>
            <p>可定制化的系统管理，实时查看入库及仓储数据；多运营多店铺管理，不同团队数据清晰; </p>
            <p>专业团队操作、专属客服对接、系统财务核算;</p>
            <p>高效、专业、智能.</p>

          </div>
        </div>
        <div class="item">
          <div class="info-box info-box2">
            <h2>尾货清仓 </h2>
            <h5>为用户提供最有价值的清仓方案，对接线下百家店铺，均位于美国东部人口最密集的区域</h5>
            <p>对接真实店主，体现真实价格，全心服务卖家，不做中间炒货商。</p>
            <p>对难以清仓的退货弃货，免费处理。 </p>

          </div>
          <div class="img-box">
            <img src="../../../static/img/web_img/img_yewu5.png" />
          </div>
        </div>
        <div class="item">
          <div class="img-box">
            <img src="../../../static/img/web_img/img_yewu6.png" />
          </div>
          <div class="info-box info-box2">
            <h2>一件代发</h2>
            <h5>为用户提供专业的仓储物流服务</h5>
            <p>已对接usps及ups和fedex等美国境内多家快递，为用户提供专业仓储物流管理。 </p>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped src="../../../static/css/enter/main.scss"></style>
<style lang="scss" scoped src="../../../static/css/enter/media.scss"></style>


// WEBPACK FOOTER //
// src/pages/web/intro.vue